<div class="list-loading">
  <div class="placeholder-label" *ngIf="hasLabel"></div>
  <div class="placeholder"></div>
  <div class="placeholder-label" *ngIf="hasLabel"></div>
  <div class="placeholder"></div>
  <div class="placeholder-label" *ngIf="hasLabel"></div>
  <div class="placeholder"></div>
  <div class="placeholder-label" *ngIf="hasLabel"></div>
  <div class="placeholder"></div>
  <div class="placeholder-label" *ngIf="hasLabel"></div>
  <div class="placeholder"></div>
</div>